import { FC, ReactNode } from 'react';
import { SxProps, Typography } from '@mui/material';

type TableCellTypographyProps = {
  children: ReactNode;
  style?: SxProps;
};

const TableCellTypography: FC<TableCellTypographyProps> = ({
  children,
  style,
}) => {
  return (
    <Typography
      display="inline"
      variant="body2"
      whiteSpace="nowrap"
      overflow="hidden"
      textOverflow="ellipsis"
      color="var(--gray-800)"
      sx={{ ...style }}
    >
      {children}
    </Typography>
  );
};

export default TableCellTypography;
